import React from 'react';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import { Image } from '@mantine/core';
import { SectionWrapper, Panel, Badge, Divider, Body } from './certifications.style';

import { certification } from 'common/data/AppCreative';

const Certifications = () => {
  const { title, slogan, symbol, symbolAlt, verifyLabel, verifyUrl } =
    certification;

  return (
    <SectionWrapper id="certifications">
      <Container>
        <Panel>
          <Badge>
            <Image src={symbol} alt={symbolAlt} width={104} fit="contain" />
          </Badge>
          <Divider />
          <Body>
            <Heading content={title} />
            <Text className="cert-desc" content={slogan} />
            <a
              className="cert-verify"
              href={verifyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {verifyLabel}
              <span aria-hidden="true">→</span>
            </a>
          </Body>
        </Panel>
      </Container>
    </SectionWrapper>
  );
};

export default Certifications;
